module.exports = __webpack_public_path__ + "static/media/logo.38345c92.png";